var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-full-width"},[_c('p',[_vm._v("Verteilung nach Jahr")]),_c('CanvasJSChart',{attrs:{"options":_vm.options,"styles":_vm.styleOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }